// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3YPaE","title":"FrontImage_title__QNrc8"};